(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.XesLoggerAdmin = factory());
}(this, (function () { 'use strict';

  function getCookieValue(name) {
    if (document && document.cookie && document.cookie.length > 0) {
      var start = document.cookie.indexOf(name + '=');

      if (start !== -1) {
        start = start + name.length + 1;
        var end = document.cookie.indexOf(';', start);

        if (end === -1) {
          end = document.cookie.length;
        }

        return unescape(document.cookie.substring(start, end));
      }

      return '';
    }

    if (wx && wx.getStorageSync) {
      const value = wx.getStorageSync(name) || '';
      return value;
    }

    return '';
  } // 日志id 是否合法


  const isValidObjectId = str => {
    const checkForHexRegExp = new RegExp('^[0-9a-fA-F]{24}$');
    return checkForHexRegExp.test(str);
  };

  const getParams = params => {
    let names = [];
    let values = [];
    params.forEach(item => {
      names.push({
        name: item.key,
        desc: item.describe
      });

      if (item.sectionType == 1 && item.type == 'Number') {
        values.push({
          name: item.key,
          desc: item.describe,
          type: 1,
          min: item.min || 0,
          max: item.max || 0
        });
      } else if (item.sectionType == 2) {
        values.push({
          name: item.key,
          desc: item.describe,
          type: 2,
          enumeration: item.enumeration || []
        });
      }
    });
    const common = {
      names,
      values
    };
    return common;
  };

  function getClient() {
    if (window && document && document.location) {
      return 'h5';
    }

    if (wx && wx.getStorageSync) {
      return 'wxmini';
    }

    return 'other';
  }

  /*
   * JavaScript MD5
   * https://github.com/blueimp/JavaScript-MD5
   *
   * Copyright 2011, Sebastian Tschan
   * https://blueimp.net
   *
   * Licensed under the MIT license:
   * https://opensource.org/licenses/MIT
   *
   * Based on
   * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
   * Digest Algorithm, as defined in RFC 1321.
   * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
   * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
   * Distributed under the BSD License
   * See http://pajhome.org.uk/crypt/md5 for more info.
   */

  /*
  * Add integers, wrapping at 2^32. This uses 16-bit operations internally
  * to work around bugs in some JS interpreters.
  */
  function safeAdd(x, y) {
    var lsw = (x & 0xffff) + (y & 0xffff);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xffff;
  }
  /*
  * Bitwise rotate a 32-bit number to the left.
  */


  function bitRotateLeft(num, cnt) {
    return num << cnt | num >>> 32 - cnt;
  }
  /*
  * These functions implement the four basic operations the algorithm uses.
  */


  function md5cmn(q, a, b, x, s, t) {
    return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
  }

  function md5ff(a, b, c, d, x, s, t) {
    return md5cmn(b & c | ~b & d, a, b, x, s, t);
  }

  function md5gg(a, b, c, d, x, s, t) {
    return md5cmn(b & d | c & ~d, a, b, x, s, t);
  }

  function md5hh(a, b, c, d, x, s, t) {
    return md5cmn(b ^ c ^ d, a, b, x, s, t);
  }

  function md5ii(a, b, c, d, x, s, t) {
    return md5cmn(c ^ (b | ~d), a, b, x, s, t);
  }
  /*
  * Calculate the MD5 of an array of little-endian words, and a bit length.
  */


  function binlMD5(x, len) {
    /* append padding */
    x[len >> 5] |= 0x80 << len % 32;
    x[(len + 64 >>> 9 << 4) + 14] = len;
    var i;
    var olda;
    var oldb;
    var oldc;
    var oldd;
    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;

    for (i = 0; i < x.length; i += 16) {
      olda = a;
      oldb = b;
      oldc = c;
      oldd = d;
      a = md5ff(a, b, c, d, x[i], 7, -680876936);
      d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
      c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
      b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
      a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
      d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
      c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
      b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
      a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
      d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
      c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
      b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
      a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
      d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
      c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
      b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
      a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
      d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
      c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
      b = md5gg(b, c, d, a, x[i], 20, -373897302);
      a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
      d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
      c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
      b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
      a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
      d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
      c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
      b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
      a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
      d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
      c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
      b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
      a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
      d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
      c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
      b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
      a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
      d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
      c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
      b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
      a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
      d = md5hh(d, a, b, c, x[i], 11, -358537222);
      c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
      b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
      a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
      d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
      c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
      b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
      a = md5ii(a, b, c, d, x[i], 6, -198630844);
      d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
      c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
      b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
      a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
      d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
      c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
      b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
      a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
      d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
      c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
      b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
      a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
      d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
      c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
      b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
      a = safeAdd(a, olda);
      b = safeAdd(b, oldb);
      c = safeAdd(c, oldc);
      d = safeAdd(d, oldd);
    }

    return [a, b, c, d];
  }
  /*
  * Convert an array of little-endian words to a string
  */


  function binl2rstr(input) {
    var i;
    var output = '';
    var length32 = input.length * 32;

    for (i = 0; i < length32; i += 8) {
      output += String.fromCharCode(input[i >> 5] >>> i % 32 & 0xff);
    }

    return output;
  }
  /*
  * Convert a raw string to an array of little-endian words
  * Characters >255 have their high-byte silently ignored.
  */


  function rstr2binl(input) {
    var i;
    var output = [];
    output[(input.length >> 2) - 1] = undefined;

    for (i = 0; i < output.length; i += 1) {
      output[i] = 0;
    }

    var length8 = input.length * 8;

    for (i = 0; i < length8; i += 8) {
      output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << i % 32;
    }

    return output;
  }
  /*
  * Calculate the MD5 of a raw string
  */


  function rstrMD5(s) {
    return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
  }
  /*
  * Calculate the HMAC-MD5, of a key and some data (raw strings)
  */


  function rstrHMACMD5(key, data) {
    var i;
    var bkey = rstr2binl(key);
    var ipad = [];
    var opad = [];
    var hash;
    ipad[15] = opad[15] = undefined;

    if (bkey.length > 16) {
      bkey = binlMD5(bkey, key.length * 8);
    }

    for (i = 0; i < 16; i += 1) {
      ipad[i] = bkey[i] ^ 0x36363636;
      opad[i] = bkey[i] ^ 0x5c5c5c5c;
    }

    hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
    return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
  }
  /*
  * Convert a raw string to a hex string
  */


  function rstr2hex(input) {
    var hexTab = '0123456789abcdef';
    var output = '';
    var x;
    var i;

    for (i = 0; i < input.length; i += 1) {
      x = input.charCodeAt(i);
      output += hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f);
    }

    return output;
  }
  /*
  * Encode a string as utf-8
  */


  function str2rstrUTF8(input) {
    return unescape(encodeURIComponent(input));
  }
  /*
  * Take string arguments and return either raw or hex encoded strings
  */


  function rawMD5(s) {
    return rstrMD5(str2rstrUTF8(s));
  }

  function hexMD5(s) {
    return rstr2hex(rawMD5(s));
  }

  function rawHMACMD5(k, d) {
    return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
  }

  function hexHMACMD5(k, d) {
    return rstr2hex(rawHMACMD5(k, d));
  }

  function md5(string, key, raw) {
    if (!key) {
      if (!raw) {
        return hexMD5(string);
      }

      return rawMD5(string);
    }

    if (!raw) {
      return hexHMACMD5(key, string);
    }

    return rawHMACMD5(key, string);
  }

  /*
   * @Date: 2021-01-24 16:45:28
   * @LastEditors: jiangqian
   * @LastEditTime: 2020-01-26 16:45:28
   */

  const vaildParams = (params, configParams, logs) => {
    let logParams = params;

    if (logParams) {
      // 如果不是对象提示错误信息
      if (typeof logParams != 'object') {
        console.error('参数配置应传对象');
      } else {
        //  验证展现日志参数是否在公共参数里面
        for (let i in logParams) {
          const type = typeof logParams[i];

          if (type == 'undefined') {
            logParams[i] = '';
          } // 已定义参数，判断类型


          if (configParams[i]) {
            const configType = configParams[i].type.toLowerCase();

            if (type !== configType) {
              // 尝试转格式
              if (configType === 'number') {
                logParams[i] = Number(logParams[i]) || 0;
              } else if (configType === 'string' && type === 'number') {
                logParams[i] = String(logParams[i]);
              }

              console.error(`打点参数${i}的类型应为：${configType}`);
            }
          } else {
            // 不存在打点转string放行
            if (type !== 'object' || type === 'object' && logParams[i] instanceof Array) {
              logParams[i] = String(logParams[i]);
            }

            console.error(`eventid: ${logs.eventid}中不存在打点参数${i}`);
          }
        }
      }
    }

    return logParams;
  }; // click参数验证和合并


  const vaildClickParams = (params, clickObj = {}, logs) => {
    console.log('上报的参数', Object.assign({}, params));
    let logParams = Object.assign({}, params);

    if (logParams) {
      // 如果不是对象提示错误信息
      if (typeof logParams !== 'object') {
        console.error('参数配置应传对象');
      } else {
        let clickid = logParams.clickid;
        let clickItem = clickObj[clickid];

        if (clickid && clickItem) {
          // 在配置中，开始校验类型和参数
          // 先校验clickid
          const type = typeof clickid;
          const configType = clickItem.type.toLowerCase();

          if (type !== configType) {
            // 尝试转格式
            if (configType === 'number') {
              logParams.clickid = Number(logParams.clickid) || 0;
            } else if (configType === 'string' && type === 'number') {
              logParams.clickid = String(logParams.clickid);
            }

            console.warn(`打点参数clickid的类型应为：${configType}`);
          }

          let otherParams = Object.assign({}, params);
          delete otherParams.clickid;
          delete otherParams.action;
          delete otherParams.elemname; // 校验其他参数

          otherParams = vaildParams(otherParams, clickItem.others, logs); // 合并参数

          Object.assign(logParams, {
            action: clickItem.action,
            elemname: clickItem.elemname
          }, clickItem.othersVal, otherParams);
          console.log('合并参数', logParams);
        } else {
          // 不在配置中
          console.warn(`未配置日志参数交互日志${clickid}`);
        }
      }
    }

    return logParams;
  }; // 日志参数初始化


  const initLogsData$1 = logs => {
    const xesid = getCookieValue('xesId');
    const sessionid = md5(xesid + '_' + new Date().getTime());
    let logOptions = {
      common: {
        eventid: logs.eventid,
        sessionid
      },
      loadMsg: {
        open: false
      },
      hashchange: {
        open: false
      },
      param: {
        sessionid
      },
      appid: {
        'localhost': {
          appid: '1001128'
        },
        'activity.xueersi.com': {
          appid: '1001132'
        },
        'huodong.xueersi.com': {
          appid: '1001961',
          appkey: '8a1fb3304fff3af30aa08b4bc3c3f1a1'
        },
        'm.xueersi.com': {
          appid: '1001977',
          appkey: 'e5dfbfaf4f65f27072224c0e34491f89'
        },
        'z.xueersi.com': {
          appid: '1001970',
          appkey: 'a6f7dc25365ba352413de883858c5136'
        },
        'h5.xesv5.com': {
          appid: '1001564',
          appkey: 'f06adda872621d6964158d494316ff9c'
        },
        'h5.xueersi.com': {
          appid: '1001970',
          appkey: 'bb44dee00f385994078571e79202f526'
        },
        'z.xueersi.com': {
          appid: '1001970',
          appkey: 'bb44dee00f385994078571e79202f526'
        },
        'app.xueersi.com': {
          appid: '1002444'
        }
      }
    };
    let commonParams = {};
    logs.commonParams.forEach(item => {
      commonParams[item.key] = item;
      logOptions.param[item.key] = item.val;
    });
    let clickObj = {};
    logs.clickList.forEach(item => {
      let clickItem = {
        clickid: item.clickid,
        action: item.action,
        type: item.type,
        elemname: item.elemname,
        others: {},
        othersVal: {}
      };
      (item.others || []).forEach(other => {
        clickItem.others[other.key] = other;
        clickItem.othersVal[other.key] = other.val;
      });
      clickObj[item.clickid] = clickItem;
    });
    return {
      logOptions,
      commonParams,
      clickObj
    };
  };

  let XesLoggerAdmin$2 = function (options, Vue) {
    let xesLogger;
    let XesLoggerSDK;
    const client = getClient();

    if (client == 'h5') {
      XesLoggerSDK = require('./logs/h5log.js');
    } else if (client == 'wxmini') {
      XesLoggerSDK = require('./logs/minilog.js');
    } else {
      throw '未知平台';
    }

    try {
      if (options && isValidObjectId(options)) {
        const logs = require(`@xes/logfile-webpack-plugin/dist/logfiles/${options}.json`);

        console.log('logs=====', logs);
        const {
          logOptions,
          commonParams,
          clickObj
        } = initLogsData$1(logs);

        if (client == 'h5') {
          xesLogger = new XesLoggerSDK(logOptions, Vue);
        } else {
          xesLogger = new XesLoggerSDK(logOptions);
        }

        const clickMsg = xesLogger.clickMsg;
        const loadMsg = xesLogger.loadMsg; // 重写日志埋点
        // 校验埋点参数是否存在，类型是否正确，添加公共日志参数，公共日志参数是否重复

        xesLogger.loadMsg = async params => {
          let logParams = params; // 展现日志是否需要单独提出来配置，还是取日志的公共参数

          try {
            logParams = vaildClickParams(logParams, clickObj, logs);
            await loadMsg(logParams);
          } catch (error) {
            console.error(`展现日志打点错误,错误信息：${error}`);
            await loadMsg(logParams);
          }
        }; // 交互日志


        xesLogger.clickMsg = async rq => {
          let logParams = Object.assign({}, rq.params);

          try {
            logParams = vaildClickParams(logParams, clickObj, logs);
            const clickParams = Object.assign({}, rq, {
              params: logParams
            });

            if (client == 'h5') {
              await clickMsg(clickParams);
            } else {
              await clickMsg(logParams);
            }
          } catch (error) {
            console.error(`交互日志打点错误,错误信息：${error}`);

            if (client == 'h5') {
              await clickMsg(rq);
            } else {
              await clickMsg(rq.params);
            }
          } // console.log('logParams', logParams)

        }; // 设置公共日志参数


        xesLogger.setCommonParam = params => {
          // 校验公共日志参数
          const logParams = vaildParams(params, commonParams, logs);
          Object.assign(logOptions.param, logParams || {});
          Object.assign(xesLogger.opts.param, logOptions.param, logParams || {});
        };
      } else {
        throw Error('日志文档id缺失或不正确');
      }
    } catch (error) {
      const xesid = getCookieValue('xesId');
      const sessionid = md5(xesid + '_' + new Date().getTime());
      const logOptions = {
        common: {
          eventid: 'other-logs-' + options,
          sessionid
        },
        loadMsg: {
          open: false
        },
        hashchange: {
          open: false
        },
        param: {
          sessionid
        },
        appid: {
          'localhost': {
            appid: '1001128'
          },
          'activity.xueersi.com': {
            appid: '1001132'
          },
          'huodong.xueersi.com': {
            appid: '1001961',
            appkey: '8a1fb3304fff3af30aa08b4bc3c3f1a1'
          },
          'm.xueersi.com': {
            appid: '1001977',
            appkey: 'e5dfbfaf4f65f27072224c0e34491f89'
          },
          'z.xueersi.com': {
            appid: '1001970',
            appkey: 'a6f7dc25365ba352413de883858c5136'
          },
          'h5.xesv5.com': {
            appid: '1001564',
            appkey: 'f06adda872621d6964158d494316ff9c'
          },
          'h5.xueersi.com': {
            appid: '1001970',
            appkey: 'bb44dee00f385994078571e79202f526'
          },
          'z.xueersi.com': {
            appid: '1001970',
            appkey: 'bb44dee00f385994078571e79202f526'
          },
          'app.xueersi.com': {
            appid: '1002444'
          }
        }
      };

      if (client == 'h5') {
        xesLogger = new XesLoggerSDK(logOptions, Vue);
      } else {
        xesLogger = new XesLoggerSDK(logOptions);
      }

      const clickMsg = xesLogger.clickMsg;

      xesLogger.setCommonParam = params => {
        Object.assign(logOptions.param, params || {});
      };

      xesLogger.clickMsg = async rq => {
        if (client == 'h5') {
          await clickMsg(rq);
        } else {
          // 小程序上报的时候没有params;
          await clickMsg(rq.params);
        }
      };

      if (options && isValidObjectId(options)) {
        console.error(`日志文档不存在，请检查日志id: ${options}`);
      } else {
        console.error('日志文档id缺失或不正确');
      }
    }

    this.xesLogger = xesLogger;
  };

  XesLoggerAdmin$2.prototype = {
    constructor: XesLoggerAdmin$2
  };

  XesLoggerAdmin$2.prototype.setCommonParam = function (params) {
    this.xesLogger.setCommonParam(params);
  };

  XesLoggerAdmin$2.prototype.loadMsg = async function (params) {
    await this.xesLogger.loadMsg(params);
  };

  XesLoggerAdmin$2.prototype.clickMsg = async function (params) {
    await this.xesLogger.clickMsg(params);
  };

  XesLoggerAdmin$2.install = async function (Vue, options) {
    let xesLogger;

    if (!Vue.prototype.$xesLogger) {
      xesLogger = new XesLoggerAdmin$2(options, Vue);
      Vue.prototype.$xesLogger = xesLogger;
    }
  };

  const errorCodeList = {
    1: '多报',
    2: '错报',
    3: '漏报',
    4: '其他'
  };
  const defalutList = ['sessionid', 'log_admin_id', 'log_admin_version'];

  const validParams = ({
    params = {},
    configParams = {},
    commonParams = {},
    commonParamsValues = {},
    logs = {},
    inputLog = {},
    rule = {},
    log_type,
    isError = false
  }) => {
    let logParams = Object.assign({}, commonParamsValues, params);
    let configDefault = Object.assign({}, commonParams, configParams);

    const getError = code => {
      const res = isError ? `${rule.id}-${rule.elemname}-${errorCodeList[code]}` : `设置公共参数-${errorCodeList[code]}`;
      return res;
    };

    if (logParams) {
      // 如果不是对象提示错误信息
      if (typeof logParams != 'object') {
        console.error('参数配置应传对象');
      } else {
        if (isError) {
          for (let j in configDefault) {
            // console.log('logParams.hasOwnProperty(j)', logParams.hasOwnProperty(j), j)
            if (!logParams.hasOwnProperty(j)) {
              const error_reason = `${3}(${getError(3)})_${j}_${configDefault[j].describe}`;
              throw JSON.stringify({
                error_code: 3,
                error_reason,
                input_log: inputLog,
                trigger_rule: rule,
                log_type
              }, null, 4);
            }
          } //  验证展现日志参数是否在公共参数里面

        }

        for (let i in logParams) {
          const type = typeof logParams[i];
          const item = logParams[i];

          if (type == 'undefined') {
            logParams[i] = '';
          } // 已定义参数，判断类型


          if (configDefault[i]) {
            const defaultItem = configDefault[i];
            const configType = defaultItem.type.toLowerCase(); // 参数类型不符

            if (type !== configType) {
              // console.error(`打点参数${i}的类型应为：${configType}`);
              const error_reason = `${2}(${getError(2)})_${i}_${defaultItem.describe}`;
              throw JSON.stringify({
                error_code: 2,
                error_reason,
                input_log: inputLog,
                trigger_rule: rule,
                log_type
              }, null, 4);
            }

            if (defaultItem.sectionType == 1 && configType == 'number') {
              // 不在数值区间
              if (item < defaultItem.min || item > defaultItem.max) {
                // console.error(`打点参数${i}的应在：[${defaultItem.min}, ${defaultItem.max}]区间内`);
                const error_reason = `${2}(${getError(2)})_${i}_${defaultItem.describe}`;
                throw JSON.stringify({
                  error_code: 2,
                  error_reason,
                  input_log: inputLog,
                  trigger_rule: rule,
                  log_type
                }, null, 4);
              }
            }

            if (defaultItem.sectionType == 2) {
              // 不在枚举区间
              if (!defaultItem.enumeration.includes(item)) {
                // console.error(`打点参数${i}的应在：[${s}]区间内`);
                const error_reason = `${2}(${getError(2)})_${i}_${defaultItem.describe}`;
                throw JSON.stringify({
                  error_code: 2,
                  error_reason,
                  input_log: inputLog,
                  trigger_rule: rule,
                  log_type
                }, null, 4);
              }
            }
          } else {
            // 不存在打点
            // console.error(`eventid: ${logs.eventid}中不存在打点参数${i}`);
            if (!defalutList.includes(i)) {
              const error_reason = `${1}(${getError(1)})_${i}_未定义`;
              throw JSON.stringify({
                error_code: 1,
                error_reason,
                input_log: inputLog,
                trigger_rule: rule,
                log_type
              }, null, 4);
            }
          }
        }
      }
    }

    return logParams;
  }; // click参数验证和合并


  const validClickParams = ({
    params,
    clickObj = {},
    logs,
    commonParamsValues = {},
    commonParams = {},
    logType
  }) => {
    console.log('上报的参数', Object.assign({}, params));
    const log_type = logType == 'click' ? 'interactive' : 'pv';
    let logParams = Object.assign({}, params);

    try {
      if (logParams) {
        // 如果不是对象提示错误信息
        if (typeof logParams !== 'object') {
          console.error('参数配置应传对象');
          const error_reason = `${4}(clickid-${errorCodeList[4]})_参数配置应传对象_未定义`;
          throw JSON.stringify({
            error_code: 4,
            error_reason,
            input_log: {},
            trigger_rule: {},
            log_type
          }, null, 4);
        } else {
          const inputLog = Object.assign({}, commonParamsValues, logParams); // 删除默认的数据

          defalutList.forEach(a => {
            delete inputLog[a];
          });
          let clickid = logParams.clickid; // 如果在白名单内，不进行校验

          if (logs.whiteList.includes(String(clickid))) {
            return logParams;
          } // 正常校验


          let clickItem = clickObj[clickid];

          if (clickid && clickItem) {
            // 在配置中，开始校验类型和参数
            // 先校验clickid
            const type = typeof clickid;
            const configType = clickItem.type.toLowerCase();

            if (type !== configType) {
              // console.warn(`打点参数clickid的类型应为：${configType}`);
              const error_reason = `${2}(clickid类型-${errorCodeList[2]})_${clickid}_${clickItem.elemname}`;
              throw JSON.stringify({
                error_code: 2,
                error_reason,
                input_log: inputLog,
                trigger_rule: clickItem.rule,
                log_type
              }, null, 4);
            } // 交互日志和展现日志打的不对


            if (clickItem.action == 'click' && logType != 'click' || (clickItem.action == 'pv' || clickItem.action == 'show') && logType != 'pv') {
              const error_reason = `${2}(clickid交互展现类型-${errorCodeList[2]})_${clickid}_${clickItem.elemname}`;
              throw JSON.stringify({
                error_code: 2,
                error_reason,
                input_log: inputLog,
                trigger_rule: clickItem.rule,
                log_type
              }, null, 4);
            }

            let otherParams = Object.assign({}, logParams);
            delete otherParams.clickid;
            delete otherParams.elemname;
            delete otherParams.action; // 校验其他参数

            otherParams = validParams({
              params: otherParams,
              commonParamsValues,
              commonParams,
              configParams: clickItem.others,
              logs,
              inputLog,
              log_type,
              rule: clickItem.rule,
              isError: true
            }); // 合并参数

            Object.assign(logParams, {
              action: clickItem.action,
              elemname: clickItem.elemname
            }, clickItem.othersVal, otherParams);
            console.log('合并参数', logParams);
          } else {
            // 不在配置中
            // console.warn(`未配置日志参数交互日志${clickid}`);
            const error_reason = `${1}(clickid-${errorCodeList[1]})_${clickid}_未定义`;
            throw JSON.stringify({
              error_code: 1,
              // 多报
              error_reason,
              input_log: inputLog,
              trigger_rule: {},
              log_type
            }, null, 4);
          }
        }
      }

      return logParams;
    } catch (error) {
      // console.log('error----', error)
      throw error;
    }
  };

  /*
   * @Date: 2021-01-24 16:45:28
   * @LastEditors: jiangqian
   * @LastEditTime: 2020-01-26 16:45:28
   */
  /*
     * @Date: 2021-01-24 16:45:28
     * @LastEditors: jiangqian
     * @LastEditTime: 2020-01-26 16:45:28
     */

  /*
     * @Date: 2021-01-24 16:45:28
     * @LastEditors: jiangqian
     * @LastEditTime: 2020-01-26 16:45:28
     */
  // 要修改的内容
  // 公共参数是否有漏报没法判断，因为不是一次全部设置的
  // 如果是第三方组件库里面的埋点上报，这个如何处理在平台录入的问题---白名单
  // 一、公共参数
  // 1、设置公共参数时，是否存在、是否类型不符、是否设置区间或枚举，是否在区间或枚举内
  // 2、上报时，通过交互日志去排查
  // 二、交互日志
  // 1、某条日志是否存在，多报
  // 2、某条日志参数 是否存在，参数多报
  // 3、某条日志参数，是否必传，未传，参数漏报
  // 4、某条日志参数，是否类型不符，错报
  // 5、某条日志参数，是否设置区间或枚举，是否在区间或枚举内，错报

  /***
   * error_code 1：多报 2：错报 3：漏报  4 ：其它
   * error_reason: 具体错误原因 ${error_code}_${clickid}(${name})_${desc}
   * input_log 原始日志
   * trigger_rule 被判定为错误触发的规则
   * log_type 表示日志类型，pv :展示日志 interactive：交互日志
  */

  const uploadErrorLog = async ({
    error_code,
    input_log = {},
    trigger_rule = {},
    log_type,
    error_reason
  }, xesLogger, logId, version) => {
    // 1：多报 2：错报 3：漏报  4 ：其它
    // const sdk_error_msg = {
    //   error_code,
    //   error_reason,
    //   input_log,
    //   trigger_rule,
    //   log_type
    // };
    (await xesLogger.cacheUploader) && xesLogger.cacheUploader({
      log_admin_id: logId,
      log_admin_version: version,
      sdk_error_code: error_code,
      sdk_error_reason: error_reason,
      sdk_input_log: JSON.stringify(input_log),
      sdk_trigger_rule: JSON.stringify(trigger_rule),
      sdk_log_type: log_type
    }, 'c', 'network');
  }; // 日志参数初始化


  const initLogsData = logs => {
    const xesid = getCookieValue('xesId');
    const sessionid = md5(xesid + '_' + new Date().getTime());
    let logOptions = {
      cacheUploader: {
        interval: 1000,
        batch: 5
      },
      common: {
        eventid: logs.eventid,
        sessionid
      },
      loadMsg: {
        open: false
      },
      hashchange: {
        open: false
      },
      param: {
        sessionid,
        log_admin_id: logs._id
      },
      appid: {
        'localhost': {
          appid: '1001128'
        },
        'activity.xueersi.com': {
          appid: '1001132'
        },
        'huodong.xueersi.com': {
          appid: '1001961',
          appkey: '8a1fb3304fff3af30aa08b4bc3c3f1a1'
        },
        'm.xueersi.com': {
          appid: '1001977',
          appkey: 'e5dfbfaf4f65f27072224c0e34491f89'
        },
        'z.xueersi.com': {
          appid: '1002147',
          appkey: 'a6f7dc25365ba352413de883858c5136'
        },
        'h5.xesv5.com': {
          appid: '1001564',
          appkey: 'f06adda872621d6964158d494316ff9c'
        },
        'h5.xueersi.com': {
          appid: '1001970',
          appkey: 'bb44dee00f385994078571e79202f526'
        },
        'app.xueersi.com': {
          appid: '1002444'
        }
      }
    };

    if (logs.version) {
      logOptions.param.log_admin_version = logs.version;
    }

    let commonParams = {};
    logs.commonParams.forEach(item => {
      commonParams[item.key] = item;
      logOptions.param[item.key] = item.val;
    });
    const commonP = getParams(logs.commonParams);
    let clickObj = {};
    logs.clickList.forEach(item => {
      let clickItem = {
        clickid: item.clickid,
        action: item.action,
        type: item.type,
        elemname: item.elemname,
        others: {},
        othersVal: {}
      };
      const ruleParams = getParams(item.others);
      const rule = {
        id: item.clickid,
        elemname: item.elemname,
        ...ruleParams,
        common_p: commonP
      };
      clickItem.rule = rule;
      (item.others || []).forEach(other => {
        clickItem.others[other.key] = other;
        clickItem.othersVal[other.key] = other.val;
      });
      clickObj[item.clickid] = clickItem;
    });
    return {
      logOptions,
      commonParams,
      clickObj,
      commonParamsRule: commonP
    };
  };

  let XesLoggerAdmin$1 = function (options, Vue) {
    let xesLogger;
    let XesLoggerSDK;
    const client = getClient();

    if (client == 'h5') {
      XesLoggerSDK = require('./logs/h5log.js');
    } else if (client == 'wxmini') {
      XesLoggerSDK = require('./logs/minilog.js');
    } else {
      throw '未知平台';
    }

    try {
      let logs = null;
      let logType = '';

      if (typeof options === 'string' && isValidObjectId(options)) {
        logs = require(`@xes/logfile-webpack-plugin/dist/logfiles/${options}.json`);
        logType = 'v1';
      }

      if (typeof options === 'object' && isValidObjectId(options.id) && isValidObjectId(options.version)) {
        logs = require(`@xes/logfile-webpack-plugin/dist/logfiles/${options.version}.json`);
        logs.version = options.version;
        logType = 'v2';
      }

      if (logs) {
        console.log('logs=====', logs);
        const {
          logOptions,
          commonParams,
          clickObj,
          commonParamsRule
        } = initLogsData(logs, logType);

        if (client == 'h5') {
          xesLogger = new XesLoggerSDK(logOptions, Vue);
        } else {
          xesLogger = new XesLoggerSDK(logOptions);
        }

        const clickMsg = xesLogger.clickMsg;
        const loadMsg = xesLogger.loadMsg; // 重写日志埋点
        // 校验埋点参数是否存在，类型是否正确，添加公共日志参数，公共日志参数是否重复

        xesLogger.loadMsg = async params => {
          let logParams = params; // 展现日志是否需要单独提出来配置，还是取日志的公共参数

          try {
            logParams = validClickParams({
              params: logParams,
              clickObj,
              logs,
              commonParamsValues: logOptions.param,
              commonParams: commonParams,
              logType: 'pv'
            });
            await loadMsg(logParams);
          } catch (error) {
            console.error(`展现日志打点错误,错误信息：`, error);
            await uploadErrorLog(JSON.parse(error), xesLogger, logs._id, logs.version);
          }
        }; // 交互日志


        xesLogger.clickMsg = async rq => {
          let logParams = Object.assign({}, rq.params);

          try {
            logParams = validClickParams({
              params: logParams,
              clickObj,
              logs,
              commonParamsValues: logOptions.param,
              commonParams: commonParams,
              logType: 'click'
            });
            const clickParams = Object.assign({}, rq, {
              params: logParams
            });

            if (client == 'h5') {
              await clickMsg(clickParams);
            } else {
              await clickMsg(logParams);
            }
          } catch (error) {
            console.error(`交互日志打点错误,错误信息:`, error);
            await uploadErrorLog(JSON.parse(error), xesLogger, logs._id, logs.version);
          } // console.log('logParams', logParams)

        }; // 设置公共日志参数


        xesLogger.setCommonParam = async params => {
          try {
            // 校验公共日志参数
            const logParams = validParams({
              params,
              configParams: commonParams,
              logs,
              inputLog: { ...params
              },
              rule: {
                common_p: commonParamsRule
              },
              isError: false
            });
            Object.assign(logOptions.param, logParams || {});
            Object.assign(xesLogger.opts.param, logOptions.param, logParams || {});
          } catch (error) {
            console.error(`设置公共日志参数错误,错误信息：`, error);
            await uploadErrorLog(JSON.parse(error), xesLogger, logs._id, logs.version);
          }
        };
      } else {
        throw '日志文档id缺失或不正确';
      }
    } catch (error) {
      console.log('error', error); //   const xesid = getCookieValue('xesId')

      const xesid = getCookieValue('xesId');
      const sessionid = md5(xesid + '_' + new Date().getTime());
      const logOptions = {
        common: {
          eventid: 'other-logs-' + (typeof options === 'object' ? options.id : options),
          sessionid
        },
        loadMsg: {
          open: false
        },
        hashchange: {
          open: false
        },
        param: {
          sessionid
        },
        appid: {
          'localhost': {
            appid: '1001128'
          },
          'activity.xueersi.com': {
            appid: '1001132'
          },
          'huodong.xueersi.com': {
            appid: '1001961',
            appkey: '8a1fb3304fff3af30aa08b4bc3c3f1a1'
          },
          'm.xueersi.com': {
            appid: '1001977',
            appkey: 'e5dfbfaf4f65f27072224c0e34491f89'
          },
          'z.xueersi.com': {
            appid: '1001970',
            appkey: 'a6f7dc25365ba352413de883858c5136'
          },
          'h5.xesv5.com': {
            appid: '1001564',
            appkey: 'f06adda872621d6964158d494316ff9c'
          },
          'h5.xueersi.com': {
            appid: '1001970',
            appkey: 'bb44dee00f385994078571e79202f526'
          },
          'z.xueersi.com': {
            appid: '1001970',
            appkey: 'bb44dee00f385994078571e79202f526'
          },
          'app.xueersi.com': {
            appid: '1002444'
          }
        }
      };

      if (client == 'h5') {
        xesLogger = new XesLoggerSDK(logOptions, Vue);
      } else {
        xesLogger = new XesLoggerSDK(logOptions);
      }

      const clickMsg = xesLogger.clickMsg;

      xesLogger.setCommonParam = params => {
        Object.assign(logOptions.param, params || {});
      };

      xesLogger.clickMsg = async rq => {
        if (client == 'h5') {
          await clickMsg(rq);
        } else {
          // 小程序上报的时候没有params;
          await clickMsg(rq.params);
        }
      };

      if (options && isValidObjectId(options)) {
        console.error(`日志文档不存在，请检查日志id: ${options}`);
      } else {
        console.error('日志文档id缺失或不正确');
      }
    }

    this.xesLogger = xesLogger;
  };

  XesLoggerAdmin$1.prototype = {
    constructor: XesLoggerAdmin$1
  };

  XesLoggerAdmin$1.prototype.setCommonParam = async function (params) {
    await this.xesLogger.setCommonParam(params);
  };

  XesLoggerAdmin$1.prototype.loadMsg = async function (params) {
    await this.xesLogger.loadMsg(params);
  };

  XesLoggerAdmin$1.prototype.clickMsg = async function (params) {
    await this.xesLogger.clickMsg(params);
  };

  XesLoggerAdmin$1.install = async function (Vue, options) {
    let xesLogger;

    if (!Vue.prototype.$xesLogger) {
      xesLogger = new XesLoggerAdmin$1(options, Vue);
      Vue.prototype.$xesLogger = xesLogger;
    }
  };

  /*
   * @Date: 2021-01-24 16:45:28
   * @LastEditors: jiangqian
   * @LastEditTime: 2020-01-26 16:45:28
   */

  let XesLoggerAdmin = function (options, Vue) {
    let xesLogger;

    if (typeof options === 'string') {
      xesLogger = new XesLoggerAdmin$2(options, Vue);
    } else if (typeof options === 'object') {
      xesLogger = new XesLoggerAdmin$1(options, Vue);
    } else {
      console.error('error', '=====日志初始化参数错误====');
    }

    console.log('xesLogger', xesLogger);
    this.xesLogger = xesLogger;
  };

  XesLoggerAdmin.prototype = {
    constructor: XesLoggerAdmin
  };

  XesLoggerAdmin.prototype.setCommonParam = async function (params) {
    await this.xesLogger.setCommonParam(params);
  };

  XesLoggerAdmin.prototype.loadMsg = async function (params) {
    await this.xesLogger.loadMsg(params);
  };

  XesLoggerAdmin.prototype.clickMsg = async function (params) {
    await this.xesLogger.clickMsg(params);
  };

  XesLoggerAdmin.install = async function (Vue, options) {
    let xesLogger;

    if (!Vue.prototype.$xesLogger) {
      xesLogger = new XesLoggerAdmin(options, Vue);
      Vue.prototype.$xesLogger = xesLogger;
    }
  };

  return XesLoggerAdmin;

})));
